import React from 'react';
import './BetaBanner.css';

const BetaBanner = () => (
  <div className="settings-beta-banner">
    You&apos;re in <span className="pill-strong">Private Beta</span>. For urgent issues,
    reach out on Discord or open a ticket here.
  </div>
);

export default BetaBanner;
